'use client'

import { FC } from 'react'
import { DropDownSearch } from '@/root/components/tuuleliinid'
import { useCountryOptions, type SelectOption } from '@/root/modules/shared/ConfirmPage'

interface CountrySelectProps {
  id: string
  label: string
  hasError?: boolean
  errorMessage?: string
  setValue?: (name: string, value: string) => void
  initialValue?: string
  onBlur?: () => void
  className?: string
  disabled?: boolean
}

const CountrySelect: FC<CountrySelectProps> = ({
  id,
  label,
  hasError,
  errorMessage,
  setValue,
  initialValue,
  onBlur,
  className,
  disabled,
}) => {
  const { countries, isLoading } = useCountryOptions()

  const handleChange = (option: SelectOption) => {
    setValue?.(id, option.code)
  }

  return (
    <DropDownSearch
      id={id}
      label={label}
      options={countries}
      selectedValue={initialValue}
      isLoading={isLoading}
      hasError={hasError}
      errorMessage={errorMessage}
      onChange={handleChange}
      onBlur={onBlur}
      className={className}
      disabled={disabled}
    />
  )
}

export default CountrySelect
